<template>
  <div class="create-goods">
    <el-form :model="form" ref="form" label-width="70px" :inline="false" size="small">
      <el-form-item label="所属分类">
        <el-select v-model="form.category_id" placeholder="请选择商品分类">
          <el-option v-for="item in categories" :key="item.id" :label="item.category_name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input v-model.trim="form.name"></el-input>
      </el-form-item>
      <el-form-item label="英文名称">
        <el-input v-model.trim="form.name_e"></el-input>
      </el-form-item>
      <el-row :gutter="15">
        <el-col :span="12" :offset="0">
          <el-form-item label="商品价格">
            <el-input-number v-model="form.price" :precision="2" :step="0.1" controls-position="right"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="0">
          <el-form-item label="商品规格">
            <el-input v-model.trim="form.specification"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :offset="0">
          <el-form-item label="商品状态">
            <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#ff4949" :active-value=1 :inactive-value=0 active-text="显示" inactive-text="隐藏"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="了解详情">
        <el-input v-model.trim="form.description" type="textarea" autosize></el-input>
      </el-form-item>
      <el-form-item label="商品成分">
        <el-input v-model.trim="form.composition" type="textarea" autosize></el-input>
      </el-form-item>
      <el-form-item label="使用方法">
        <el-input v-model.trim="form.usage" type="textarea" autosize></el-input>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12" :offset="0">
          <el-form-item label="首图正面">
            <el-upload
              :action="uploadGoodsImageUrl"
              accept="image/png, image/jpeg, image/gif"
              name='image'
              :file-list="goodsImage1"
              :headers="headers"
              :before-upload="beforeImageUpload"
              :on-remove="()=>{form.image_1 = ''}"
              :on-preview="handlePictureCardPreview"
              :on-success="(response, file, fileList)=>{form.image_1 = response.path}"
              list-type="picture">
              <el-button size="small" type="primary" plain>点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="0">
          <el-form-item label="首图反面">
            <el-upload
              accept="image/png, image/jpeg, image/gif"
              name='image'
              :action="uploadGoodsImageUrl"
              :file-list="goodsImage2"
              :headers="headers"
              :before-upload="beforeImageUpload"
              :on-remove="()=>{form.image_2 = ''}"
              :on-preview="handlePictureCardPreview"
              :on-success="(response, file, fileList)=>{form.image_2 = response.path}"
              list-type="picture">
              <el-button size="small" type="primary" plain>点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="轮播图">
        <el-upload
          multiple
          name='image'
          accept="image/png, image/jpeg, image/gif"
          list-type="picture-card"
          :file-list="goodsSwiperImage"
          :limit="5"
          :on-exceed="overImageLimit"
          :action="uploadGoodsSwiperImageUrl"
          :headers="headers"
          :before-upload="beforeImageUpload"
          :on-preview="handlePictureCardPreview"
          :on-success="handleSwiperImageUpload"
          :on-remove="handleSwiperImageRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12" :offset="0">
          <el-form-item label="视频封面">
            <el-upload
              accept="image/png, image/jpeg"
              name='image'
              :action="uploadGoodsVideoCoverUrl"
              :file-list="videoCoverList"
              :headers="headers"
              :before-upload="beforeImageUpload"
              :on-remove="()=>{videoCover=''}"
              :on-success="(response, file, fileList)=>{videoCover = response.path}"
              list-type="picture">
              <el-button size="small" type="primary" plain>点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="0">
          <el-form-item label="视频">
            <el-upload
              accept=".mp4"
              name='video'
              :file-list="goodsVideoList"
              :action="uploadGoodsVideoUrl"
              :headers="headers"
              :before-upload="beforeVideoUpload"
              :on-remove="()=>{videoPath=''}"
              :on-success="(response, file, fileList)=>{videoPath = response.path}">
              <el-button size="small" type="primary" plain>点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="success" @click="beforeSubmit">立即更新</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialog.imagePreview" width="30%" append-to-body>
      <el-image :src="previewImage" fit="fill" style="max-height:50vh"></el-image>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/self/config.js'
export default {
  props: ['id'],
  data () {
    return {
      uploadGoodsImageUrl: '',
      uploadGoodsSwiperImageUrl: '',
      uploadGoodsVideoUrl: '',
      uploadGoodsVideoCoverUrl: '',
      headers: {
        Authorization: ''
      },
      form: {},
      swiperImages: [],
      videoPath: '',
      videoCover: '',
      categories: [],
      dialog: {
        imagePreview: false
      },
      previewImage: '',
      goodsSwiperImage: [],
      goodsVideoList: [],
      videoCoverList: [],
      goodsImage2: [],
      goodsImage1: []
    }
  },
  watch: {
    id (newV, oldV) {
      this.getGoodsInfo(newV)
    }
  },
  methods: {
    initData (info) {
      const goods = {
        id: info.id,
        name: info.name,
        name_e: info.name_e,
        category_id: info.category_id,
        image_1: info.image_1,
        image_2: info.image_2,
        price: info.price * 1,
        status: info.status,
        specification: info.specification,
        description: info.description,
        composition: info.composition,
        usage: info.usage
      }
      this.goodsImage1 = [{ name: '主图正面', url: config.imageDisplayBaseUrl + info.image_1 }]
      this.goodsImage2 = [{ name: '主图反面', url: config.imageDisplayBaseUrl + info.image_2 }]
      const goodsSwiperImage = []
      this.form = goods
      const swiper = []
      for (let i = 0; i < info.swiper.length; i++) {
        const item = info.swiper[i]
        if (item.type === 'image') {
          swiper.push(item)
          goodsSwiperImage.push({ name: item.name, url: config.imageDisplayBaseUrl + item.path })
        }
        if (item.type === 'video') {
          this.videoPath = item.path
          this.videoCover = item.coverImage
          this.videoCoverList = [{ name: '封面图', url: config.imageDisplayBaseUrl + item.coverImage }]
          this.goodsVideoList = [{ name: '视频', url: config.imageDisplayBaseUrl + item.path }]
        }
      }
      this.swiperImages = swiper
      this.goodsSwiperImage = goodsSwiperImage
    },
    cancel () {
      this.$emit('cancel')
    },
    handleSwiperImageUpload (response, file, fileList) {
      this.swiperImages.push({ name: file.name, path: file.response.path, type: 'image' })
    },
    handleSwiperImageRemove (file, fileList) {
      const images = []
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        images.push({ name: file.name, path: file.response.path, type: 'image' })
      }
      this.swiperImages = images
    },
    overImageLimit (files, fileList) {
      this.$message.warning('图片上传数量超过限制')
    },
    beforeImageUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 3MB!')
      }
      return isLt2M
    },
    beforeVideoUpload (file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传视频大小不能超过 10MB!')
      }
      return isLt10M
    },
    handlePictureCardPreview (file) {
      this.dialog.imagePreview = true
      this.previewImage = file.url
    },
    beforeSubmit () {
      if (this.form.name === '') {
        this.$message.error('请填写商品名称')
        return false
      }
      if (this.swiperImages.length < 1) {
        this.$message.error('还未上传轮播图片')
        return false
      }
      const data = JSON.parse(JSON.stringify(this.form))
      const swiper = JSON.parse(JSON.stringify(this.swiperImages))
      if (this.videoPath !== '' && this.videoCover !== '') {
        swiper.push({ name: 'video.mp4', path: this.videoPath, coverImage: this.videoCover, type: 'video' })
      }
      data.swiper = swiper
      console.log(data)
      const that = this
      this.axios.put('admin/goods/' + data.id, data).then(function (resp) {
        if (resp.data.error === 0) {
          that.$message.success('商品更新成功')
          that.$emit('success')
        }
        if (resp.data.error === 1) {
          that.$message.error(resp.data.msg)
        }
      }).catch(function () {
        that.$message.error('发生错误，请联系管理员')
      })
    },
    getCategoryData () {
      const that = this
      that.axios.get('admin/category').then(function (resp) {
        if (resp.data.error === 0) {
          that.categories = resp.data.categories
        }
      })
    },
    getGoodsInfo (id) {
      const that = this
      that.axios.get('admin/goods/' + id).then(function (resp) {
        that.initData(resp.data.goods)
      })
    }
  },
  mounted () {
    this.getCategoryData()
    this.getGoodsInfo(this.id)
    this.headers.Authorization = sessionStorage.getItem('token')
    this.uploadGoodsImageUrl = config.uploadGoodsImageUrl
    this.uploadGoodsSwiperImageUrl = config.uploadGoodsSwiperImageUrl
    this.uploadGoodsVideoUrl = config.uploadGoodsVideoUrl
    this.uploadGoodsVideoCoverUrl = config.uploadGoodsVideoCoverUrl
  }
}
</script>

<style scoped>
.create-goods{
  padding: 1px 15px 20px;
}
</style>
